import { type Atom, useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import { useEffect, useMemo } from 'react';

type Callback = (error: Error) => void | (() => void);

/**
 * Jotai Atom にエラーがあるとき、コールバックを実行する
 * @param atom Atom
 */
export function useJotaiErrorUpdate<T = unknown>(
  atom: Atom<T | Promise<T>>,
  callback: Callback
) {
  const loadableAtom = useMemo(() => loadable(atom), [atom]);
  const atomLoadable = useAtomValue(loadableAtom);
  useEffect(() => {
    if (atomLoadable.state !== 'hasError') {
      return; // エラーではないのでスキップ
    }
    return callback(atomLoadable.error as Error);
  }, [atomLoadable, callback]);
}
